import * as React from "react";

const IconDelete = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.36 3.491c0-.6-.504-1.09-1.12-1.09H5.76c-.616 0-1.12.49-1.12 1.09H2.4v2.182h1.12v7.636c0 .6.504 1.091 1.12 1.091h6.72c.616 0 1.12-.49 1.12-1.09V5.673h1.12V3.491h-2.24Zm-5.6 8.728a.547.547 0 0 1-.56.545.547.547 0 0 1-.56-.545V6.764c0-.305.246-.545.56-.545.313 0 .56.24.56.545v5.455Zm2.8 0a.547.547 0 0 1-.56.545.547.547 0 0 1-.56-.545V6.764c0-.305.246-.545.56-.545.313 0 .56.24.56.545v5.455Zm2.8 0a.547.547 0 0 1-.56.545.547.547 0 0 1-.56-.545V6.764c0-.305.246-.545.56-.545.313 0 .56.24.56.545v5.455Z"
      fill={props.fill || "#4F4FFF"}
    />
  </svg>
);

export default IconDelete;
